import { updateClinics } from "../../FindClinicMap/find-clinic-map";
import { getCurrentPosition } from "../../Google/Maps/google-maps";
import { initializeModal } from "../../Shared/Modal/modal";
import { updateFormFilterFacets } from "../../Shared/Utilities/filterFacets";

const form = document.getElementById(
  "find-emergency-clinic-form"
) as HTMLFormElement | null;

// Note: Not throwing here due to missing form, since there's no form if location services are enabled
if (form) {
  const positionButton = form.querySelector<HTMLButtonElement>(`[data-position-button]`);

  const geolocationFailedModal = form.querySelector<HTMLElement>(
    "[data-geolocation-failed-modal]"
  );

  if (!geolocationFailedModal) {
    throw "Emergency page geolocationFailedModal missing";
  }

  const mapId = "find-emergency-clinic-map";

  const geolocationFailedModalDefinition = initializeModal(geolocationFailedModal);

  const filterDropdowns = document.querySelectorAll<HTMLElement>(
    "[data-filter-dropdown]"
  );

  filterDropdowns.forEach(filterDropdown => {
    const select = filterDropdown.querySelector("select");

    select?.addEventListener("change", async _ => {
      // Submit the form whenever a filter is updated
      form.requestSubmit();
    });
  });

  if (positionButton) {
    positionButton.addEventListener("click", async e => {
      try {
        positionButton.classList.toggle("htmx-request");
        positionButton.disabled = true;

        const position = await getCurrentPosition();

        const params = new URLSearchParams({
          geolocation: "true",
          latitude: `${position.latitude}`,
          longitude: `${position.longitude}`
        });

        const redirectUrl = new URL(window.location.href);

        redirectUrl.search = params.toString();

        window.location.href = redirectUrl.href;
      } catch (error) {
        console.warn(error);

        positionButton.classList.toggle("htmx-request");
        positionButton.disabled = false;

        e.preventDefault();

        geolocationFailedModalDefinition?.open();
      }
    });
  }

  form.addEventListener("htmx:afterOnLoad", async _ => {
    const updatedFilterFacetsElement = document.querySelector<HTMLElement>(
      "#find-emergency-clinic-search-results [data-facets-json]"
    );

    updateFormFilterFacets(form, updatedFilterFacetsElement);

    await updateClinics(mapId);
  });
}
